import { render } from "./reissue-password.vue?vue&type=template&id=231a7707"
import script from "./reissue-password.vue?vue&type=script&lang=js"
export * from "./reissue-password.vue?vue&type=script&lang=js"

import "./reissue-password.vue?vue&type=style&index=0&id=231a7707&lang=css"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__